// import { DatePicker } from 'antd'
import { PlusCircle } from 'feather-icons-react/build/IconComponents'
import React from 'react'
import { Link } from 'react-router-dom'
import Select from 'react-select'
// import ImageWithBasePath from '../../img/imagewithbasebath'

const EditPurchaseReturns = () => {
    const suppliers = [
        { value: 'choose', label: 'Choose' },
        { value: 'apexComputers', label: 'Apex Computers' },
        { value: 'modernAutomobile', label: 'Modern Automobile' },
        { value: 'aimInfotech', label: 'AIM Infotech' },
      ];
    //   const status = [
    //     { value: 'choose', label: 'Choose' },
    //     { value: 'pending', label: 'Pending' },
    //     { value: 'received', label: 'Received' },
    //   ];
    //   const [selectedDate, setSelectedDate] = useState(new Date());
    //   const handleDateChange = (date) => {
    //       setSelectedDate(date);
    //   };
    return (
        <div>
            {/*Edit popup */}
            <div className="modal fade mt-4" id="edit-sales-new">
                <div className="modal-dialog add-centered">
                    <div className="modal-content mt-5">
                        <div className="page-wrapper p-0 m-0">
                            <div className="content p-0">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Edit Purchase Request</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close d-flex ms-auto"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span className='fs-3' aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-lg-4 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label className="form-label">Supplier</label>
                                                        <div className="row">
                                                            <div className="col-lg-10 col-sm-10 col-10">
                                                            <Select  className="select" options={suppliers} />
                                                            </div>
                                                            <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                                                <div className="add-icon">
                                                                    <Link to="#" className="choose-add">
                                                                        <PlusCircle className="plus"/>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Date</label>
                                                        <div className="input-groupicon">
                                                            <input 
                                                                className='form-control' 
                                                                type='date' 
                                                                // value={selectedDate}
                                                                // onChange={handleDateChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-5 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label className="form-label">Notes</label>
                                                        <input type="text" className='form-control'  placeholder='Enter notes'></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Product Name</label>
                                                        <div className="input-groupicon select-code">
                                                            <Select />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive no-pagination">
                                                <table className="table  datanew">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>Quantity</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>Apex Computers </td>
                                                            <td>
                                                                <input
                                                                    type='number'
                                                                    className='form-control'
                                                                    style={{width: '10rem' }}
                                                                    value="20"
                                                                />
                                                            </td>
                                                            
                                                            <td>
                                                                <button className='btn btn-light'>
                                                                    <i className='fa fa-trash'></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            <div className="row mt-4">
                                                
                                                <div className="col-lg-12 text-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-cancel add-cancel me-3"
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button type="submit" className="btn btn-submit add-sale">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Edit popup */}
        </div>
    )
}

export default EditPurchaseReturns